var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',{staticClass:"d-block text--title pt-4 px-5 pb-2 text-truncate mt-n1"},[_vm._v(_vm._s(_vm.value.name ? _vm.value.name : "No Name"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }